export default {
      id: "icon-paused-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-paused",
      toString: function () {
        return this.url;
      }
    }